import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function bridgeClient(token) {
  return axios.create({
    baseURL: API_BASE,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
}

async function request(promise) {
  try {
    const res = await promise;
    const body = res?.data;
    if (body?.success === false) {
      const err = new Error(body.message || 'Request failed');
      err.code = body.code;
      err.status = res.status;
      throw err;
    }
    return body?.data ?? body;
  } catch (e) {
    const body = e.response?.data;
    const err = new Error(body?.message || e.message || 'Request failed');
    err.code = body?.code;
    err.status = e.response?.status;
    throw err;
  }
}

export const bridgeCollectionService = {
  getCollection: (token) =>
    request(axios.get(`${API_BASE}/bridge/collection/${encodeURIComponent(token)}`)),

  initiateLabourPayment: (token, { idempotencyKey, method }) => {
    const client = bridgeClient(token);
    return request(client.post('/bridge/payment/labour', { idempotencyKey, method }));
  },

  markCashAtGarage: (token) => {
    const client = bridgeClient(token);
    return request(client.post('/bridge/payment/cash-at-garage'));
  },

  verifyPayment: (token, razorpayPayload) => {
    const client = bridgeClient(token);
    return request(client.post('/payment/verify', razorpayPayload));
  },

  getInvoice: (token) =>
    request(axios.get(`${API_BASE}/bridge/invoice/${encodeURIComponent(token)}`)),

  downloadInvoicePdf: async (token, filename) => {
    const res = await axios.get(`${API_BASE}/bridge/invoice/${encodeURIComponent(token)}/pdf`, {
      responseType: 'blob',
    });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'invoice.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default bridgeCollectionService;

function normalizeCollectionUrl(url) {
  if (!url) return '';
  try {
    const parsed = new URL(url);
    const token = decodeURIComponent(parsed.pathname.replace(/^\/bridge\/collection\//, ''));
    if (!token) return url;
    return `${window.location.origin}/bridge/collection/${token}`;
  } catch {
    const match = String(url).match(/\/bridge\/collection\/([^?#]+)/);
    if (match) return `${window.location.origin}/bridge/collection/${match[1]}`;
    return url;
  }
}

export { normalizeCollectionUrl };
